import React, { FC } from "react";
import { Facebook, LinkedIn, Instagram, YouTube } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import { AiOutlineTikTok } from "react-icons/ai";
import { FaThreads } from "react-icons/fa6";
import { socialProfiles, type SocialPlatform } from "../../constants/social_links";
import { useBrandContact } from "../../lib/LiveContext";
import styles from "../../styles/components/_shared/SocialLinks.module.scss";

/**
 * The outline icon for each platform, shared by this block and the thank-you
 * pages, which render the same circles inside their own layout.
 */
export const socialIcon = (name: SocialPlatform, className?: string): React.ReactNode => {
  switch (name) {
    case "Facebook":
      return <Facebook className={className} />;
    case "Instagram":
      return <Instagram className={className} />;
    case "LinkedIn":
      return <LinkedIn className={className} />;
    case "YouTube":
      return <YouTube className={className} />;
    case "TikTok":
      return <AiOutlineTikTok className={className} />;
    case "Threads":
      return <FaThreads className={className} />;
    case "X":
      return <XIcon className={className} />;
  }
};

// Every profile of the page's brand contact, in the footer's order.
const SocialLinks: FC<Props> = ({ size = "medium" }) => {
  const profiles = socialProfiles(useBrandContact());

  return (
    <div className={`${styles.socials} ${styles[size]}`}>
      {profiles.map((link) => (
        <a
          href={link.url}
          key={link.name}
          target="_blank"
          rel="noreferrer"
          // The icons are decorative glyphs with no text beside them, so each
          // link needs its own accessible name.
          aria-label={`SOLS Foundation on ${link.name}`}
          className={styles.icon}
        >
          {socialIcon(link.name)}
        </a>
      ))}
    </div>
  );
};

interface Props {
  // `medium` matches the 3rem circles on the thank-you pages. `small` is for
  // inline use inside a notice or a paragraph block.
  size?: "small" | "medium";
}

export default SocialLinks;
